module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/crear-supernet/crear-supernet.component.css
// module id = ./src/app/crear-supernet/crear-supernet.component.css
// module chunks = main